import type { Perimeter } from '@atlassian/atl-context';

import { CategoryStorageType } from '../../../types';

const generateResourcePath = (source: string, perimeter: string, type: string): string => {
	const baseCloudfrontS3CommercialPath = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/';
	const baseCloudfrontS3FedrampPath = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/';

	const baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
	const baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';

	const fileName = `categories_${type}.json`;

	if (source === 'cloudfrontS3') {
		switch (perimeter) {
			case 'fedramp':
				return `${baseCloudfrontS3FedrampPath}${fileName}`;
			case 'commercial':
				return `${baseCloudfrontS3CommercialPath}${fileName}`;
			default:
				return `${baseCloudfrontS3CommercialPath}${fileName}`;
		}
	}

	switch (perimeter) {
		case 'fedramp':
			return `${baseBifrostFedrampPath}${fileName}`;
		case 'commercial':
			return `${baseBifrostCommercialPath}${fileName}`;
		default:
			return `${baseBifrostCommercialPath}${fileName}`;
	}
}

export const getCommercialCategoryCacheUrlLookup = (shouldUseBifrostSources: boolean): Record<CategoryStorageType, string> => {
	const distribution = shouldUseBifrostSources ? 'bifrost' : 'cloudfrontS3';
	return {
		[CategoryStorageType.Cookies]: generateResourcePath(distribution, 'commercial', 'COOKIE'),
		[CategoryStorageType.LocalStorage]: generateResourcePath(distribution, 'commercial', 'LOCAL_STORAGE'),
		[CategoryStorageType.SessionStorage]: generateResourcePath(distribution, 'commercial', 'SESSION_STORAGE'),
		[CategoryStorageType.IndexedDB]: generateResourcePath(distribution, 'commercial', 'INDEXED_DB'),
	};
};

export const getCategoryCacheUrlPerimeterLookup = (shouldUseBifrostSources: boolean): Partial<
	Record<Perimeter, Record<CategoryStorageType, string>>
> => {
	const distribution = shouldUseBifrostSources ? 'bifrost' : 'cloudfrontS3';
	return {
		commercial: getCommercialCategoryCacheUrlLookup(shouldUseBifrostSources),
		'fedramp-moderate': {
			[CategoryStorageType.Cookies]: generateResourcePath(distribution, 'fedramp', 'COOKIE'),
			[CategoryStorageType.LocalStorage]: generateResourcePath(distribution, 'fedramp', 'LOCAL_STORAGE'),
			[CategoryStorageType.SessionStorage]: generateResourcePath(distribution, 'fedramp', 'SESSION_STORAGE'),
			[CategoryStorageType.IndexedDB]: generateResourcePath(distribution, 'fedramp', 'INDEXED_DB'),
		},
	};
};
